/**
 * Gộp các lần gọi TRÙNG của cùng một API.
 *
 * Bản web của `mobile/src/core/services/request-dedupe.ts` — giữ nguyên hành vi
 * để hai đầu client cùng một luật (đọc mô tả đầy đủ ở file bên mobile).
 *
 * Hai lớp chống trùng:
 * 1. Đang bay (in-flight): các lời gọi song song dùng chung một promise.
 * 2. TTL ngắn: gọi lại ngay sau khi vừa có kết quả thì trả lại kết quả đó.
 *
 * Lỗi KHÔNG bao giờ được cache — lần gọi sau vẫn ra server thật.
 *
 * @param {{ttlMs?: number, now?: () => number}} [options]
 *        ttlMs: kết quả còn "tươi" trong bao lâu; now: tiêm đồng hồ cho test.
 */
export function createDedupedRequest({ ttlMs = 3000, now = Date.now } = {}) {
    let inflight = null;
    let cached = null;

    return {
        /**
         * @param {() => Promise<any>} fetcher hàm gọi API thật (chỉ chạy khi không gộp được).
         * @param {boolean} [force] bỏ qua cả in-flight lẫn TTL, luôn ra server.
         */
        run(fetcher, force = false) {
            if (!force) {
                if (inflight) return inflight;
                if (cached && now() - cached.at < ttlMs) return Promise.resolve(cached.value);
            }
            const request = fetcher()
                .then((value) => {
                    cached = { value, at: now() };
                    return value;
                })
                .finally(() => {
                    // Chỉ dọn nếu vẫn là request mới nhất (force có thể đã thay bằng cái khác).
                    if (inflight === request) inflight = null;
                });
            inflight = request;
            return request;
        },

        /** Vứt cache + quên request đang bay. Gọi khi dữ liệu chắc chắn đã cũ. */
        reset() {
            inflight = null;
            cached = null;
        },
    };
}
